module.exports = __webpack_public_path__ + "img/ayala.50742a49.png";